@switch (mode) { @case (LabelMode.DEFAULT) {
<ng-container [ngTemplateOutlet]="default"></ng-container>
} @case (LabelMode.INLINE) {
<ng-container [ngTemplateOutlet]="inline"></ng-container>
} @case (LabelMode.NO_LABEL) {
<ng-container [ngTemplateOutlet]="input"></ng-container>
} }

<ng-template #input>
  <ng-select [id]="name" class="{{ inputClass }} w-100" [ngClass]="{ error: isError }" [appendTo]="appendTo!"
    [formControl]="form" [items]="options" bindLabel="{{ bindLabel }}" bindValue="{{ bindValue }}"
    [placeholder]="placeholder | translate" [loading]="isLoading" [clearable]="clearable" [searchable]="searchable"
    groupBy="{{ groupBy }}" [multiple]="isMultiple" [selectableGroup]="selectableGroup"
    [selectableGroupAsModel]="selectableGroupAsModel" [closeOnSelect]="closeOnSelect"
    [clearSearchOnAdd]="clearSearchOnAdd" [searchFn]="onSearchFn" (click)="onSelectClick()" (clear)="onClearSelected()"
    (search)="onSearch($event)" (change)="onInputChange($event)"></ng-select>
  <!-- <ng-select
  [id]="name"
  class="{{ inputClass }}"
  [ngClass]="{ error: isError }"
  [appendTo]="appendTo"
  [formControl]="form"
  [items]="options$ | async"
  bindLabel="{{ bindLabel }}"
  bindValue="{{ bindValue }}"
  [placeholder]="placeholder | translate"
  [loading]="isLoading"
  [clearable]="clearable"
  [searchable]="searchable"
  [typeahead]="search$"
></ng-select> -->
  @if (isError) {
  <span class="error">{{ errorMessage | translate }}</span>
  }
</ng-template>

<ng-template #default>
  <div class="form-group" [ngClass]="classes">
    <label [for]="name" class="col-form-label fw-semibold fs-6 py-2" [ngClass]="required ? 'required' : ''">{{ label |
      translate }}
      @if (addonLabel && addonLabel != '*') {
      <span class="{{ addonLabelClass }}">({{ addonLabel | translate }})</span>
      } @if (addonLabel && addonLabel === '*') {
      <span class="{{ addonLabelClass }}">{{ addonLabel | translate }}</span>
      }
    </label>
    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>

<ng-template #inline>
  <div class="form-group form-group-inline" [ngClass]="classes">
    <label [for]="name" class="col-form-label fw-semibold fs-6 py-2" [ngClass]="required ? 'required' : ''">{{ label |
      translate }}</label>
    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>